// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"156ea79a","5410":"08c2af8b"}[chunkId] + ".chunk.css";
};